/* eslint-disable jsx-a11y/anchor-is-valid */
import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {useNavigate} from 'react-router-dom'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import {formatPhone} from '../../../utils/formater'
import moment from 'moment'
import {i18n} from '../../../translate/i18n'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import usePluginSpace from '../../../hooks/usePluginSpace'
import {Dropdown} from 'react-bootstrap'
import {CreatableSelect} from '../../../components/CreateSelect/createSelect'
import Swal from 'sweetalert2'
import useModals from '../../../hooks/useModals'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import styles from './listaCliente.module.css'

// type CustomerResponseType = {
//   id: number
//   name: string
//   email: string
//   order: string
//   phone: string
// }

const ListaClientesContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const {getPluginSpace} = usePluginSpace()
  const [isWholeSaler, setIsWholeSaler] = useState(false)

  const [customers, setCustomers] = useState<any[]>([])
  /*Configuracao da DataTable */
  const [headers, setHeaders] = useState<any[]>([
    {key: i18n.t(`customer_list.name`), value: 'name', type: 'default'},
    {key: 'Email', value: 'email', type: 'default'},
    {key: i18n.t(`customer_list.phone`), value: 'phone', type: 'default'},
    {key: i18n.t(`customer_list.date`), value: 'created', type: 'default'},
    {key: i18n.t(`general.actions`), value: 'acoes', type: ''},
  ])
  const [options, setOptions] = useState<any[]>([
    {
      icon: '',
      isButton: true,
      textButton: i18n.t(`buttons.view`),
      action: (item: any) => {
        //navigate(`/customer/report/${btoa(item.id)}`)
        window.open(`/customer/report/${btoa(item.id)}`)
      },
      color: 'primary',
    },
  ])

  const [customerGroups, setCustomersGroups] = useState<{id: string; name: string}[]>([])
  const [customerGroupSelected, setCustomersGroupSelected] = useState<{id: string; name: string}>({
    id: '0',
    name: 'Ambos',
  }) // Default to "Ambos" group
  const [status] = useState([
    {value: '', select: 'Ambos'},
    {value: 'active', select: 'Ativo'},
    {value: 'inactive', select: 'Inativo'},
    {value: 'blocked', select: 'Bloqueado'},
    {value: 'pending', select: 'Pendente'},
  ])
  const [statusSelected, setStatusSelected] = useState('')

  /**Usado para o modal */
  const [action, setAction] = useState<'importCustomer' | 'alterStatus' | 'alterGroup'>(
    'alterStatus'
  )
  const {showWrapperModal} = useModals()
  const [fileToImport, setFileToImport] = useState<File | null>(null)
  const [statusSelectedChangeModal, setStatusSelectedChangeModal] = useState('')
  const [customerGroupSelectedChangeModal, setCustomersGroupSelectedChangeModal] =
    useState<{id: string; name: string}>()

  function translateStatus(status: string) {
    switch (status) {
      case 'active':
        return 'Ativo'
      case 'inactive':
        return 'Inativo'
      case 'blocked':
        return 'Bloqueado'
      case 'pending':
        return 'Pendente'

      default:
        return 'Não informado'
    }
  }

  const getClients = async (loading = true) => {
    try {
      const aux = await configDataTable()

      const res = !aux
        ? await POST('/customer/filter', {internal: true})
        : await POST('/customer/filter_whole_saller', {internal: true})
      const customers = res.data.map((row: any) => {
        const principalPhone = row.customerPhones.find(
          (phone: {typePhone: string; numberPhone: string}) =>
            phone.typePhone === 'principal' && phone.numberPhone !== ''
        ) || {numberPhone: ''}

        return {
          id: row.id,
          name: row.name,
          email: row.email ? row.email : '-/-',
          status: translateStatus(row.status),
          phone:
            principalPhone && principalPhone.numberPhone
              ? formatPhone(principalPhone.numberPhone)
              : '-/-',
          created: moment(row.created).utcOffset(-3).format('DD/MM/YYYY HH:mm:ss'), // Adjusted to Brazil time
          group: row.customerGroupMemberships
            ? row.customerGroupMemberships.group?.name
            : 'Sem Grupo',
          selected: false,
        }
      })
      setCustomers(customers)
    } catch (e) {
      console.log(e)
    }
  }

  const loadClients = async (isWholeSalerAux?: boolean) => {
    const data = {}

    if (statusSelected) Object.assign(data, {status: statusSelected})
    if (customerGroupSelected && (isWholeSalerAux || isWholeSaler))
      Object.assign(data, {customerGroupId: customerGroupSelected.id})
    if (name) Object.assign(data, {name: name})
    if (email) Object.assign(data, {email: email})

    Object.assign(data, {internal: true})

    try {
      setLoading(true)
      const filter = !(isWholeSalerAux || isWholeSaler)
        ? await POST('/customer/filter', data)
        : await POST('/customer/filter_whole_saller', data)
      const customers = filter.data.map((row: any) => {
        // Get the most recent principal phone if available
        const principalPhone = row.customerPhones.find(
          (phone: {typePhone: string; numberPhone: string}) => phone.numberPhone !== ''
        ) || {numberPhone: ''}

        return {
          id: row.id,
          name: row.name,
          email: row.email ? row.email : '-/-',
          status: translateStatus(row.status),
          phone:
            principalPhone && principalPhone.numberPhone
              ? formatPhone(principalPhone.numberPhone)
              : '-/-',
          created: moment(row.created).utcOffset(-3).format('DD/MM/YYYY HH:mm:ss'), // Adjusted to Brazil time
          group: row.customerGroupMemberships
            ? row.customerGroupMemberships.group?.name
            : 'Sem Grupo',
          selected: false,
        }
      })
      setCustomers(customers)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  async function configDataTable() {
    try {
      const thisPluginsSpace = await getPluginSpace(true)

      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        setHeaders([
          {key: i18n.t(`customer_list.name`), value: 'name', type: 'default'},
          {key: 'Email', value: 'email', type: 'default'},
          {key: i18n.t(`customer_list.phone`), value: 'phone', type: 'default'},
          {key: i18n.t(`customer_list.date`), value: 'created', type: 'default'},
          {key: 'Grupo', value: 'group', type: 'default'},
          {key: 'Status', value: 'status', type: 'default'},
          {key: i18n.t(`general.actions`), value: 'acoes', type: ''},
        ])
        setOptions([
          {
            icon: '',
            isButton: true,
            textButton: i18n.t(`buttons.view`),
            action: (item: any) => {
              //navigate(`/customer/report/${btoa(item.id)}`)
              window.open(`/customer/report/${btoa(item.id)}`)
            },
            color: 'primary',
          },
        ])

        return true
      }

      return false
    } catch (error) {
      console.log(error)
      return false
    }
  }

  async function getCustomersGroups() {
    try {
      const res = await GET('/customer_groups')
      const groups = res.data.map((row: any) => {
        return {
          id: row.id,
          name: row.name,
        }
      })
      setCustomersGroups([{id: 0, name: 'Ambos'}, {id: -1, name: 'Sem grupo'}, ...groups])
    } catch (error) {
      console.log(error)
    }
  }

  async function loadAll() {
    setLoading(true)

    const aux = await configDataTable()
    if (aux) {
      await getCustomersGroups()
    }
    await loadClients(aux)
    setLoading(false)
  }

  function onSelectAll(all: boolean, id: number, value: boolean) {
    try {
      const newCustomers = customers.map((row: any) => {
        if (all) {
          row.selected = value
        }
        if (!all && row.id === id) {
          row.selected = !row.selected
        }
        return row
      })

      setCustomers(newCustomers)
    } catch (error) {
      console.log(error)
      return
    }
  }

  async function createGroupCustomer(value: string) {
    try {
      const response = await POST('/customer_groups', {name: value})

      if (!response || !response.success) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Erro ao criar grupo de clientes!',
          customClass: {
            container: `${styles.swalContainer}`,
          },
        })
        return
      }
      await getCustomersGroups()
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Grupo de clientes criado com sucesso!',
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Erro ao criar grupo de clientes!',
      })
    }
  }

  const importFile = async () => {
    try {
      if (!fileToImport) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se foi selecionado um arquivo!',
        })
      } else {
        setLoading(true)
        const formData = new FormData()
        formData.append('file', fileToImport)

        const importRes = await POST('/customer/create_whole_saler_csv', formData)

        setLoading(false)
        if (importRes.success) {
          const data = importRes.data

          if (data.invalidos && data.invalidos.length > 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Importação Concluída',
              text: `A importação foi realizada com sucesso, porém ${data.invalidos.length} clientes não puderam ser importados.
              Você pode baixar o arquivo CSV com os detalhes das falhas clicando no botão abaixo.`,
              showCancelButton: true,
              confirmButtonText: 'Visualizar CSV',
              cancelButtonText: 'Fechar',
            }).then((result) => {
              if (result.isConfirmed) {
                window.open('/order/logs', '_blank')
              }
            })
            return
          }
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Importação realizada com sucesso!',
          })
        } else {
          let msg = 'Erro ao importar arquivo!'

          if (importRes.msg) {
            msg = importRes.msg
          }

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: msg,
          }).then(async () => await getClients())
        }
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e,
      }).then(async () => await getClients())
    }
    setFileToImport(null)
  }

  async function modalFuctions(action: 'importCustomer' | 'alterStatus' | 'alterGroup') {
    switch (action) {
      case 'importCustomer':
        return importFile()
      case 'alterStatus':
        return alterStatusCustomer()
      case 'alterGroup':
        return alterGroupCustomer()
      default:
        return null
    }
  }

  async function alterStatusCustomer() {
    try {
      if (!statusSelectedChangeModal) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Selecione um status!',
        })
        return
      }

      const data = customers
        .filter((row) => row.selected)
        .map((row) => ({
          id: row.id,
          status: statusSelectedChangeModal,
          alteredStatus: true,
        }))
      setLoading(true)
      const res = await POST('/customer/status/multiples', data)
      setLoading(false)
      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Status alterado com sucesso!',
        }).then(async () => await loadClients())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao alterar status!',
        }).then(async () => await loadClients())
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Erro ao alterar status!',
      }).then(async () => await loadClients())
    }
  }
  async function alterGroupCustomer() {
    try {
      if (!customerGroupSelectedChangeModal) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Selecione um grupo!',
        })
        return
      }
      const data = {
        data: customers
          .filter((row) => row.selected)
          .map((row) => {
            return {
              customerId: row.id,
              groupId: customerGroupSelectedChangeModal.id,
            }
          }),
      }
      setLoading(true)
      const res = await POST('/customer_groups/vinculate_customer', data)
      setLoading(false)
      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Grupo de clientes alterado com sucesso!',
        }).then(async () => await loadClients())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao alterar grupo de clientes!',
        }).then(async () => await loadClients())
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Erro ao alterar grupo de clientes!',
      }).then(async () => await loadClients())
    }
  }

  useEffect(() => {
    loadAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-12 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <div className='card-toolbar d-flex justify-content-between w-100'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.customer`)}
                  </span>
                  <BreadCrumbs />
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    {i18n.t(`customer_list.listed_customers`)}
                  </span>
                </h3>
                {isWholeSaler && (
                  <div className='card-toolbar'>
                    <Button
                      icon='fas fa-plus'
                      color='primary'
                      size='small'
                      text={i18n.t(`customer_list.create`)}
                      click={() => navigate('/customer/report/create')}
                      btnClass='ms-10 float-right'
                    />

                    <Dropdown
                      className='btn btn-primary btn-sm fw-bolder me-5 p-0'
                      style={{marginLeft: '1em'}}
                    >
                      <Dropdown.Toggle variant='default' size='sm'>
                        <i className='bi bi-three-dots fs-4 p-0'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className='p-0'>
                        <Dropdown.Item
                          onClick={() => {
                            setAction('importCustomer')
                            showWrapperModal('Importar XMLX')
                          }}
                          className='p-0 d-flex flex-row justify-content-center'
                        >
                          <div
                            className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                            style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              className='bi bi-filetype-csv'
                              viewBox='0 0 16 16'
                              style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                            >
                              <path
                                fill-rule='evenodd'
                                d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z'
                              />
                            </svg>
                            <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                              Importar CSV
                            </p>
                          </div>
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            const selectes = customers.filter((row) => row.selected)
                            if (selectes.length === 0) {
                              Swal.fire({
                                icon: 'warning',
                                title: 'Atenção!',
                                text: 'Selecione ao menos um cliente!',
                              })
                              return
                            }

                            setAction('alterStatus')
                            showWrapperModal('Alterar Status')
                          }}
                          className='p-0 d-flex flex-row justify-content-center'
                        >
                          <div
                            className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                            style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                          >
                            <i
                              className='bi bi-patch-check'
                              style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                            ></i>
                            <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                              Alterar Status
                            </p>
                          </div>
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            const selectes = customers.filter((row) => row.selected)
                            if (selectes.length === 0) {
                              Swal.fire({
                                icon: 'warning',
                                title: 'Atenção!',
                                text: 'Selecione ao menos um cliente!',
                              })
                              return
                            }

                            setAction('alterGroup')
                            showWrapperModal('Alterar Grupo')
                          }}
                          className='p-0 d-flex flex-row justify-content-center'
                        >
                          <div
                            className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                            style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                          >
                            <i
                              className='bi bi-people'
                              style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                            ></i>
                            <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                              Alterar Grupo
                            </p>
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
            <div className='card-body'>
              <div className='w-100 mb-10'>
                <div className='d-flex align-items-end mt-5 row'>
                  {isWholeSaler && (
                    <div className='col-md-3'>
                      <CreatableSelect
                        options={customerGroups}
                        label={'Grupo de Clientes'}
                        placeholder={i18n.t(`customer.select_group`)}
                        placeholder2={i18n.t(`customer.search_custom`)}
                        onSelect={function (item: {id: string | number; name: string}): void {
                          setCustomersGroupSelected({
                            ...item,
                            id: item.id ? item.id.toString() : '',
                          })
                        }}
                        value={customerGroupSelected}
                        onCreate={function (name: string): void {
                          createGroupCustomer(name)
                        }}
                      />
                    </div>
                  )}
                  <div className='col-md-2'>
                    <Input
                      inputAttr={{type: 'default'}}
                      label={i18n.t(`customer_list.name`)}
                      value={name}
                      change={setName}
                      placeholder={i18n.t(`customer_list.name`)}
                    />
                  </div>
                  <div className='col-md-2'>
                    <Input
                      inputAttr={{type: 'email'}}
                      label='Email'
                      value={email}
                      change={setEmail}
                      placeholder='Email'
                    />
                  </div>
                  {isWholeSaler && (
                    <div className='col-md-2'>
                      <Input
                        inputAttr={{type: 'select'}}
                        label='Status'
                        value={statusSelected}
                        change={(value: any) => setStatusSelected(value)}
                        options={status}
                      />
                    </div>
                  )}
                  <div
                    className={`${isWholeSaler ? 'col-3' : 'col-8'} d-flex  
                    justify-content-md-end  mt-md-0 mt-5`}
                  >
                    <Button
                      color='primary'
                      icon='fa fa-filter'
                      text={i18n.t(`buttons.filter`)}
                      click={() => loadClients()}
                      btnClass=''
                    />
                  </div>
                </div>
              </div>
              <Datatable
                data={customers}
                headers={headers}
                options={options}
                selectable={isWholeSaler}
                onSelectable={onSelectAll}
                color='primary'
                loadTable
              />
            </div>
          </div>
        </div>
      )}

      <ModalWrapper
        confirmAction={() => modalFuctions(action)}
        textAction={action === 'importCustomer' ? 'Importar' : 'Salvar'}
        zIndex={1000}
        shouldCloseModal={true}
      >
        {action === 'importCustomer' && (
          <>
            <div className='flex-grow-1'>
              <p className='fs-2'>{i18n.t(`general.attention`)}</p>
              <p className='fs-6'>Baixe o modelo para importar o arquivo corretamente.</p>
              <p className='fs-6 fw-light text-danger'>*obs: os campos em amarelo são opcionais.</p>
              <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                <div style={{width: '30%'}}>
                  <Button
                    text={'Modelo'}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      window.open('/file/modelo_customer_atacado.xlsx', '')
                    }}
                    btnClass='fw-bolder me-5'
                  />
                </div>
              </div>
            </div>
            <br />
            <div className='flex-grow-1 text-center d-flex flex-row'>
              <Input
                inputAttr={{
                  type: 'file',
                }}
                acceptFile={'.xlsx,.xls'}
                change={(value: BaseSyntheticEvent) =>
                  setFileToImport(value ? value.target.files[0] : null)
                }
              />
            </div>
          </>
        )}
        {action === 'alterGroup' && (
          <>
            <div className='mt-1'>
              <span>Os itens abaixo serão alterados</span>
            </div>
            <div
              className='d-flex flex-column overflow-scroll'
              style={{
                height: '8rem',
                border: '1px solid #949392',
              }}
            >
              {/* eslint-disable-next-line array-callback-return */}
              {customers.map((elemento) => {
                if (elemento.selected === true) {
                  return <span className='ms-2'>{elemento.name}</span>
                }
              })}
            </div>

            <div>
              <CreatableSelect
                options={customerGroups.filter((e) => e.id.toString() !== '0')}
                label={'Grupo de Clientes'}
                onSelect={function (item: {id: string | number; name: string}): void {
                  setCustomersGroupSelectedChangeModal({
                    ...item,
                    id: item.id ? item.id.toString() : '',
                  })
                }}
                value={customerGroupSelectedChangeModal}
                onCreate={function (name: string): void {
                  createGroupCustomer(name)
                }}
              />
            </div>
          </>
        )}
        {action === 'alterStatus' && (
          <>
            <div className='mt-1'>
              <span>Os itens abaixo serão alterados</span>
            </div>
            <div
              className='d-flex flex-column overflow-scroll'
              style={{
                height: '8rem',
                border: '1px solid #949392',
              }}
            >
              {/* eslint-disable-next-line array-callback-return */}
              {customers.map((elemento) => {
                if (elemento.selected === true) {
                  return <span className='ms-2'>{elemento.name}</span>
                }
              })}
            </div>

            <div>
              <Input
                inputAttr={{type: 'select'}}
                label='Status'
                value={statusSelectedChangeModal}
                change={(value: any) => setStatusSelectedChangeModal(value)}
                options={[
                  {value: '', select: 'Selecionar'},
                  {value: 'active', select: 'Ativo'},
                  {value: 'inactive', select: 'Inativo'},
                  {value: 'blocked', select: 'Bloqueado'},
                  {value: 'pending', select: 'Pendente'},
                ]}
              />
            </div>
          </>
        )}
      </ModalWrapper>
    </>
  )
}

const ListaClientes: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`customer_list.customer_list`), path: 'customer/report', isActive: true},
        ]}
      >
        {i18n.t(`customer_list.customer_list`)}
      </PageTitle>
      <ListaClientesContent />
    </>
  )
}

export {ListaClientes}
